// projects/humanresources-payroll/src/assets/i18n/*/hr-pay-group-work-subarea.json
export class HrPayGroupWorkSubareaKey {
    private static readonly keyPrefix = 'hrPayGroupWorkSubarea';
    public static pageHeader = `${HrPayGroupWorkSubareaKey.keyPrefix}.pageHeader`;
    public static shortPageHeader = `${HrPayGroupWorkSubareaKey.keyPrefix}.shortPageHeader`;
    public static workAreaUuid = `${HrPayGroupWorkSubareaKey.keyPrefix}.workAreaUuid`;
    public static workSubareaUuid = `${HrPayGroupWorkSubareaKey.keyPrefix}.workSubareaUuid`;
    public static workSubareaWageGroup = `${HrPayGroupWorkSubareaKey.keyPrefix}.workSubareaWageGroup`;
}
